import { useEffect, useState } from 'react';
import './listing-gallery.css';

export default function ListingGalleryEnhancer() {
  const [photos,setPhotos] = useState<string[]>([]);
  const [activeIndex,setActiveIndex] = useState<number|null>(null);

  useEffect(()=>{
    const clickImage = (event:Event) => {
      const img = event.currentTarget as HTMLImageElement;
      const current = collectPhotos();
      const index = Math.max(0,current.indexOf(img.src));
      setPhotos(current);
      setActiveIndex(index);
    };
    const bind = () => {
      const current = collectPhotos();
      const strip = document.querySelector<HTMLElement>('.listing-photo-strip');
      if (strip) strip.dataset.photoCount = String(current.length);
      document.querySelectorAll<HTMLImageElement>('.listing-detail-photo .listing-photo-frame img,.listing-photo-strip img').forEach((img)=>{
        if (img.dataset.marineGalleryBound === '1') return;
        img.dataset.marineGalleryBound = '1';
        img.classList.add('marine-gallery-image');
        img.addEventListener('click',clickImage);
      });
    };
    const observer = new MutationObserver(bind);
    observer.observe(document.body,{subtree:true,childList:true});
    bind();
    return ()=>{
      observer.disconnect();
      document.querySelectorAll<HTMLImageElement>('[data-marine-gallery-bound="1"]').forEach((img)=>{
        img.removeEventListener('click',clickImage);
        delete img.dataset.marineGalleryBound;
      });
    };
  },[]);

  useEffect(()=>{
    if (activeIndex == null) return;
    const onKey = (event:KeyboardEvent) => {
      if (event.key === 'Escape') setActiveIndex(null);
      if (event.key === 'ArrowRight') setActiveIndex((old)=>old==null?old:(old+1)%Math.max(photos.length,1));
      if (event.key === 'ArrowLeft') setActiveIndex((old)=>old==null?old:(old-1+Math.max(photos.length,1))%Math.max(photos.length,1));
    };
    window.addEventListener('keydown',onKey);
    return ()=>window.removeEventListener('keydown',onKey);
  },[activeIndex,photos.length]);

  if (activeIndex == null || !photos[activeIndex]) return null;
  return <div className="listing-lightbox" onMouseDown={()=>setActiveIndex(null)}>
    <button className="listing-lightbox-close" onClick={()=>setActiveIndex(null)} aria-label="Close photo viewer">×</button>
    {photos.length>1&&<button className="listing-lightbox-nav prev" onMouseDown={(event)=>event.stopPropagation()} onClick={()=>setActiveIndex((activeIndex-1+photos.length)%photos.length)}>‹</button>}
    <div className="listing-lightbox-stage" onMouseDown={(event)=>event.stopPropagation()}>
      <img src={photos[activeIndex]} alt={`Listing photo ${activeIndex+1} of ${photos.length}`}/>
      <span>{activeIndex+1} / {photos.length}</span>
    </div>
    {photos.length>1&&<button className="listing-lightbox-nav next" onMouseDown={(event)=>event.stopPropagation()} onClick={()=>setActiveIndex((activeIndex+1)%photos.length)}>›</button>}
  </div>;
}

function collectPhotos() {
  const values = Array.from(document.querySelectorAll<HTMLImageElement>('.listing-detail-photo .listing-photo-frame img,.listing-photo-strip img')).map((img)=>img.src).filter(Boolean);
  return [...new Set(values)];
}
